export const SETTINGS_TIMERANGE_KEY = "overviewTimerangeSetting";
